
<ng-template [ngIf]="inserimento">
<div class="col-sm-12 coldx" 
	[ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
	<h4 *ngIf="title">{{title}}</h4>
	<form class="cerca_grey">
		<div class="row">
			<p class="col-sm-12">
				<label for="cerca-parc-giud-lbl">Cerca</label> <input id="cerca-parc-giud-lbl" type="text" #searchItem (keyup)="0"
					class="form-control" placeholder="Inserisci nome e cognome" />
			</p>
		</div>
	</form>
	<ng-template [ngIf]="legaliAll.length > 0">
	<ul id="controparticollapse" class="controparti">

		<ng-template ngFor
			let-legaleIncaricato [ngForOf]="legaliAll  | searchFilter : searchItem.value : 'legale.nominativo' ">

		<li class="panel">
			<div class="controparte">
				<div>
					<p class="col-xs-12 col-sm-2">
						<button class="btn btn-primary associa"
							(click)="associaLegale(legaleIncaricato);" type="submit">Associa</button>
					</p>
					<h4 class="titolo col-sm-3">
						{{legaleIncaricato.legale?.nominativo}}
					</h4>
					<ng-template [ngIf]="legaleIncaricato.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					<p class="col-sm-3 matricola">
						CF: <strong>{{legaleIncaricato.legale?.codiceFiscale}}</strong>
					</p>
					</ng-template>
					<ng-template [ngIf]="legaleIncaricato.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					<p class="col-sm-3 matricola">
						P.IVA: <strong>{{legaleIncaricato.legale?.partitaIva}}</strong>
					</p>
					</ng-template>
					<p class="col-sm-2 matricola">
						<strong>{{legaleIncaricato.categoriaLegaleIncaricato.label}}</strong>
					</p>
				</div>
			</div>
		</li>
		</ng-template>
	</ul>
	</ng-template>
	<ng-template [ngIf]="legaliAll.length == 0 && msgNoBeneficiari">
	<p>{{msgNoBeneficiari}}</p>
	</ng-template>
</div>
</ng-template>

<ng-template [ngIf]="parcellaGiudizialeForm">

<div class="col-sm-12 coldx" 
	[ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
	<h4 *ngIf="title">{{title}}</h4>
	<div class="tab-content">
		<form [formGroup]="parcellaGiudizialeForm">
			<div class="row">
				<ng-template [ngIf]="!inserimento">
				<div class="col-sm-3">
					<p>
						<label for="tipo_legale">Tipo legale</label> <select
							name="tipo_legale" class="form-control"
							(change)="populateLegali($event);">
							<ng-template ngFor let-categoria [ngForOf]="tipiLegale">
							<option value="{{categoria.id}}">{{categoria.label}}</option>
							</ng-template>
						</select>
					</p>
				</div>

				<div comboModInput class="col-sm-3" [labelInput]="'Legale'"
					formControlName="legale"
					[labelOption]="'legale.nominativo'" [objectReference]="request.legale"
					(onReturn)="request.legale = $event"
					[optionsCombo] ="legaliOptions"></div>

				</ng-template>

				<ng-template [ngIf]="inserimento && request.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Cognome e nome'" [valueInput]="request.legale?.legale.nominativo"></div>
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Tipo Legale'"
					[valueInput]="request.legale?.categoriaLegaleIncaricato.label"></div>
				</ng-template>

				<ng-template [ngIf]="inserimento && request.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Ragione sociale'" [valueInput]="request.legale?.legale.ragioneSociale"></div>
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Tipo Legale'"
					[valueInput]="request.legale?.categoriaLegaleIncaricato.label"></div>
				</ng-template>

				<div textInput class="col-sm-3" [labelInput]="'Numero parcella'"
					formControlName="numeroParcella"
					[(ngModel)]="request.numeroParcella"></div>

				<div datePickerInput class="col-sm-3" [labelInput]="'Data parcella'"
					formControlName="dataParcella" [(ngModel)]="request.dataParcella"
					[control]="parcellaGiudizialeForm.controls['dataParcella']"
					[mandatory]="true"></div>

			</div>
			<hr>
			<div class="row">
				<div comboModInput [labelInput]="'Competenza'"
					formControlName="competenza"
					(change)="populateScaglioniFromCompetenza($event.target.value);"
					[objectReference]="request.competenza"
					(onReturn)="request.competenza = $event"
					[optionsCombo] ="competenzeOptions"
					[control]="parcellaGiudizialeForm.controls['competenza']"
					[ngModel]="request.competenza"
					[mandatory]="true"
					[location]="'parcelle'"
					></div>
			</div>
			<div class="row">
				<div comboModInput [labelInput]="'Scaglione'"
					[submitPending]="!request.competenza" formControlName="scaglione"
					(change)="populateFasiCompenso($event.target.value);" [objectReference]="request.scaglione"
					(onReturn)="request.scaglione = $event"	[optionsCombo] ="scaglioniOptions"
					[control]="parcellaGiudizialeForm.controls['scaglione']" [ngModel]="request.scaglione"
					[mandatory]="true" [location]="'parcelle'"
					></div>
			</div>
			<div class="row">
				<div class="parcella col-sm-4 col-sm-offset-2 alignright">
					<div [submitPending]="true" textInputCurrency
						[labelInput]="'Valore'" formControlName="importoPetitumRiferimento"
						[(ngModel)]="request.importoPetitumRiferimento"
						[location]="'SezioneEconomica'"></div>
				</div>
			</div>
			<div parcella-giudiziale-quadro-form #quadroCompensiForm class="container_conteggi" (onReturn)="refresh($event)"></div>

			<hr>

			<div class="container_conteggi">
				<h5>
					<strong>Spese</strong>
				</h5>
				<div
					textInputCurrency [control]="parcellaGiudizialeForm.controls['spesaEsente']"
					[labelInput]="'Spese esenti (art. 15 DPR 633/72)'"
					formControlName="spesaEsente"
					[(ngModel)]="request.spesa.spesaEsente"></div>
				<div
					textInputCurrency [control]="parcellaGiudizialeForm.controls['spesaTrasferta']"
					[labelInput]="'Spese di trasferta (art. 27)'"
					formControlName="spesaTrasferta"
					[(ngModel)]="request.spesa.spesaTrasferta"></div>
				<div
					textInputCurrency [control]="parcellaGiudizialeForm.controls['altraSpesaImponibile']"
					[labelInput]="'Altre spese imponibli (non relative a trasferte)'"
					formControlName="altraSpesaImponibile"
					[(ngModel)]="request.spesa.altraSpesaImponibile"></div>
				<div
					textInputCurrency [control]="parcellaGiudizialeForm.controls['percSpesaGenerale']"
					[labelInput]="'Spese generali % (art. 2)'"
					formControlName="percSpesaGenerale"  [maxValue]="20" [defaultValue]="15" [isNaturalNumber]="true"
					[(ngModel)]="request.spesa.percSpesaGenerale"></div>
			</div>

			<div class="container_conteggi">
				<h5>
					<strong>Accessori</strong>
				</h5>

				<div class="row">
					<div class="parcella_accessori col-sm-offset-2">
						<div singleCheckBoxModInput class="col-sm-2" [labelInput]="''"
							idInput="flagIva" formControlName="flagIva"
							[labelChecked]="'IVA'" [labelNotChecked]="'IVA'"
							[objectReference]="request.flagIva"
							(onReturn)="request.flagIva = $event"></div>

						<div comboModInput class="col-sm-3" [labelInput]="''"
							formControlName="iva" [submitPending]="!request.flagIva"
							[labelOption]="'valore'" [objectReference]="request.iva"
							(onReturn)="request.iva = $event" [optionsCombo] ="ivaOptions"></div>

						<div class="col-sm-2" singleCheckBoxModInput [labelInput]="''"
							[labelChecked]="'CPA'" [labelNotChecked]="'CPA'" [showLabel]="true"
							idInput="flagCpa" formControlName="flagCpa"
							[objectReference]="request.flagCpa"
							(onReturn)="request.flagCpa = $event"></div>

						<div comboModInput class="col-sm-3" [labelInput]="''"
							formControlName="cpa" [submitPending]="!request.flagCpa"
							[labelOption]="'valore'" [objectReference]="request.cpa"
							(onReturn)="request.cpa = $event" [optionsCombo] ="cpaOptions"></div>
					</div>
				</div>

			</div>
			<div class="row">
				<div class="parcella_accessori">
					<div singleCheckBoxModInput class="col-sm-7 col-sm-offset-5 listcheckbox"
						[labelChecked]="'Ritenuta d\'\acconto'" [labelNotChecked]="'Ritenuta d\'\acconto'"
						[labelInput]="''" idInput="flagRitenutaAcconto" [showLabel]="true"
						formControlName="flagRitenutaAcconto"
						[objectReference]="request.flagRitenutaAcconto"
						(onReturn)="request.flagRitenutaAcconto = $event"></div>
				</div>
			</div>
			<div class="row">
				<p *ngIf="inserimento" class="col-sm-3"><button type="button" (click)="goToAssociaLegale();" class="btn btn-outline-secondary btn-block">Indietro</button></p>
				<p class="col-sm-3"><button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button></p>

				<p class="col-sm-3 col-xs-3 col-xs-offset-3 col-sm-offset-3">
					<button (click)="calcolaCompenso(request.legale);" type="button"
					[disabled]="!formValid() || !parcellaGiudizialeForm.valid"
						class="btn btn-primary btn-block">Calcola il compenso</button>
				</p>
			</div>

		</form>
	</div>
</div>

<div class="col-sm-12 coldx" id="pannello11" [ngStyle]="{ 'display' : ( visibleToggleRiepilogo ? 'block' : 'none') }">
	<h4>Riepilogo Parcella</h4>
	<div class="tab-content">
		<form (ngSubmit)="save();">

			<div *ngIf="riepilogo" parcella-giudiziale-riepilogo-form [parcellaGiudiziale]="riepilogo"></div>
			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<button type="button" (click)="goToForm();"	class="btn btn-outline-secondary btn-block">Indietro</button>
				</p>
				<p submitButton
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Salva'">
				</p>
			</div>
		</form>
	</div>
</div>
</ng-template>
